import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  GcInputFieldComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { TextInputData } from '../../report-input-entities';
import { OptionsButtonComponent } from '../options-button/options-button.component';
import { SaveButtonsComponent } from '../save-buttons/save-buttons.component';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.scss',
  imports: [
    GcInputFieldComponent,
    SaveButtonsComponent,
    OptionsButtonComponent,
    IpoTranslatePipe,
  ],
})
export class TextInputComponent implements OnInit, OnChanges {
  @Input() data: TextInputData;
  @Input() optionsButton? = true;
  @Input() isComment? = false;
  @Input() canBeMarkedNotApplicable? = true;
  @Output() saveInput = new EventEmitter<string>();
  @Output() cancel = new EventEmitter();
  @Output() clickIcon = new EventEmitter();
  @Output() hasUnsavedChanges = new EventEmitter<boolean>();

  inputValue = '';
  displayButtons = false;
  disableSaveButton = false;

  ngOnInit(): void {
    this.inputValue = this.data?.savedValue ?? '';
    this.setDisplayButtons(false);
    this.setDisableSaveButton();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      !changes.data.firstChange &&
      changes.data.previousValue !== changes.data.currentValue
    )
      this.inputValue = this.data?.savedValue;
  }

  setDisplayButtons(value: boolean) {
    this.displayButtons = this.isComment ? true : value;
  }

  setDisableSaveButton() {
    if (
      !this.isComment ||
      (this.inputValue.length && this.inputValue !== this.data.savedValue)
    ) {
      this.disableSaveButton = false;
    } else {
      this.disableSaveButton = true;
    }
  }

  handleOnClickCancel() {
    this.cancel.emit();
    this.inputValue = this.data?.savedValue;
    this.setDisplayButtons(false);
    this.hasUnsavedChanges.emit(false);
  }

  handleOnClickSave() {
    this.saveInput.emit(this.inputValue);
    this.data.savedValue = this.inputValue;
    this.setDisplayButtons(false);
    this.hasUnsavedChanges.emit(false);
  }

  handleOnChangeInput(input: string) {
    this.inputValue = input;
    this.setDisplayButtons(true);
    this.setDisableSaveButton();
    this.hasUnsavedChanges.emit(true);
  }
}
